export type InfiniteListControls = {
  fetchNextPage: () => Promise<unknown>;
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
  isFetching: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => Promise<unknown>;
};

export const loadNextPageIfAvailable = (
  state: Pick<
    InfiniteListControls,
    "hasNextPage" | "isFetchingNextPage" | "fetchNextPage"
  >,
) => {
  if (state.hasNextPage && !state.isFetchingNextPage) {
    void state.fetchNextPage();
  }
};
